import React, { useState } from "react";
import { Header, Sidebar } from "../../components/layout";
import { ModuleGrid } from "../../components/dashboard";

const Home: React.FC = () => {
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);

  const toggleSidebar = () => {
    setIsSidebarCollapsed(!isSidebarCollapsed);
  };

  return (
    <div className="min-h-screen bg-white">
      {/* Header - Fixed at top */}
      <div className="fixed top-0 left-0 right-0 z-50">
        <Header onToggleSidebar={toggleSidebar} />
      </div>

      {/* Main Layout */}
      <div className="flex h-screen pt-16">
        {/* Sidebar - Fixed below header */}
        <Sidebar isCollapsed={isSidebarCollapsed} onToggle={toggleSidebar} />

        {/* Main Content - Adjusted for fixed sidebar */}
        <main
          className={`flex-1 overflow-auto bg-white transition-all duration-300 ${
            isSidebarCollapsed ? "ml-16" : "ml-72"
          }`}
        >
          <div className="p-8">
            {/* Page Title */}
            {/* Page Title */}
            <div className="mb-8">
              <h1 className="text-3xl font-normal text-black">
                Quản trị hệ thống
              </h1>
              {/* gạch xám mảnh bên dưới tiêu đề */}
              <div className="mt-2 h-px w-100 bg-gray-200 rounded-full" />
            </div>

            {/* Module Grid */}
            <ModuleGrid />
          </div>
        </main>
      </div>
    </div>
  );
};

export default Home;
